// TabComponent.js
import React, { useState } from "react";
import SlideProgress from "../Progress/SlideProgress";
// import "./TabComponent.css";

const Tab = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Experian",
      content: <SlideProgress/>,
    },
    {
      title: "Equifax",
      content: <SlideProgress/>,
    },
    {
      title: "TransUnion",
      content: <SlideProgress/>,
    },
  ];

  return (
    <div className="tabs-container">
      {/* Render tab titles */}
      <div className="tabs">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Render active tab content */}
      <div className="tab-content">
        <p>{tabs[activeTab].content}</p>
      </div>
    </div>
  );
};

export default Tab;
